/**
 * SUNTEC static assets — company legal info + fallback hero image.
 *
 * NOTE: The 9 departments have been migrated to MongoDB (managed via Admin CMS).
 * Use `useDepartments()` from `@/context/DepartmentsContext` to fetch them.
 */
export const COMPANY = {
  name: "SUNTEC GROUP",
  tagline: "Soluții integrate pentru achiziții și dotări industriale",
  intro:
    "Un grup de firme specializate în achiziții pentru proiecte europene, digitalizare și producție. Facilităm accesul la tehnologie de vârf cu livrare în toată România.",
  experience: "Peste 20 ani de expertiză",
  stats: [
    { k: "300+", v: "Proiecte de achiziții implementate în România" },
    { k: "100%", v: "Conformitate cu cerințele finanțatorilor" },
    { k: "09", v: "Domenii integrate de activitate" },
    { k: "20+", v: "Ani de experiență" },
  ],
  contacts: {
    sales: { email: "sales@suntec.ro", phones: ["+40 746 111 531", "+40 741 111 887"] },
    service: { email: "service@suntec.ro", phones: ["+40 741 111 887"] },
    accounting: { email: "contabilitate@suntec.ro", phones: ["+40 746 111 529"] },
  },
  entities: [
    { name: "Suntec Trade SRL", cui: "RO 18442684", reg: "J05/426/2006", capital: "400.000 RON", iban: "RO71RNCB0032106153860003 · BCR", address: "Sat Cheriu, nr. 72, Bihor, 417362, România" },
    { name: "Suntec SRL", cui: "16106440", reg: "J15/142/2004", capital: "200 RON", iban: "RO77RNCB0032161090770001 · BCR", address: "Str. Izvorului, nr. 22, 410176, Oradea, România" },
    { name: "Suntec Outlet SRL", cui: "33163586", reg: "J05/784/2014", capital: "200 RON", iban: "RO20RNCB0032177934020001 · BCR", address: "Str. Avântului, nr. 15, 410520, Oradea, România" },
    { name: "Suntec Solutions SRL", cui: "50314875", reg: "J05/1730/2024", capital: "200 RON", iban: "RO39RNCB0032179316860001 · BCR", address: "Str. Izvorului, nr. 22, 410176, Oradea, România" },
  ],
};

export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1715156153744-d5fd2f1f66eb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBhcmNoaXRlY3R1cmUlMjBnbGFzcyUyMGJ1aWxkaW5nfGVufDB8fHxibGFja19hbmRfd2hpdGV8MTc4MzE0NTU4OXww&ixlib=rb-4.1.0&q=85";
